import client from "./client";

// 회원정보
export const userInfo = locale => client.get(`/api/${locale}/sbjUser/edit`);

// 회원정보 수정
export const userInfoModify = (locale, data) =>
  client.post(`/api/${locale}/sbjUser/edit`, data);

// 임상시험 자원서
export const applyInfo = locale => client.get(`/api/${locale}/sbjUser/sbjEdit`);

// 임상시험 자원서 수정
export const applyModify = (locale, data) =>
  client.post(`/api/${locale}/sbjUser/sbjEdit`, data);

// 회원정보 비밀번호 확인
export const pwConfirm = (locale, data) =>
client.post(`/api/${locale}/sbjUser/pwConfirm`, data);

  